import React from 'react';
import { ApplicationView, useController, raw } from '@aha-app/mvc';
import classNames from 'classnames';
import Tippy, { useSingleton } from '@tippyjs/react';
import 'tippy.js/animations/scale.css';
import styles from '../styles.module.css';
import WithHint from './WithHint';
import { TOOLTIP_DELAY_GENERAL } from '../constants';
import WhiteboardController from '../controllers/WhiteboardController';
import WithSubMenu from './WithSubMenu';
import StylusToolButton from './StylusToolButton';
import { TippyTargetProvider } from '../components/tippyContext';
import { tippyPopoverPlugin } from '../utils/tippyPopoverPlugin';

function handleClickAnalytics(name?: string) {
  window.AhaAnalytics?.track(
    'Feature-7504419665803813880',
    'User selects whiteboard toolbar option',
    {
      'Toolbar option': name ?? 'unknown',
    }
  );
}

const StylusToolbar = () => {
  const controller = useController(WhiteboardController);
  const { currentStylusMenu, hasActiveObjectTransformation } = controller.state;
  const [tippySingletonSource, tippySingletonTarget] = useSingleton();

  return (
    <div
      className={classNames(styles.stylusToolbar, styles.toolbarCommon, {
        [styles.toolbarFade]: hasActiveObjectTransformation,
      })}
    >
      <Tippy
        singleton={tippySingletonSource}
        placement='right'
        delay={TOOLTIP_DELAY_GENERAL}
        zIndex={12000}
        plugins={[tippyPopoverPlugin]}
      />

      <TippyTargetProvider value={tippySingletonTarget}>
        {controller.paletteStyluses.map((stylusInfo, i) => {
          const subMenuActive =
            raw(currentStylusMenu!) === raw(stylusInfo.stylus);

          return (
            <WithSubMenu
              key={i}
              MenuComponent={stylusInfo.stylus.subMenu() ?? undefined}
              visible={subMenuActive}
            >
              {/* This span is a workaround for tippy-react needing refs forwarded */}
              <span>
                <WithHint
                  tool={stylusInfo.tool}
                  singleton={tippySingletonTarget}
                >
                  <StylusToolButton
                    key={i}
                    stylus={stylusInfo.stylus}
                    active={subMenuActive}
                    onMouseDown={() =>
                      handleClickAnalytics(stylusInfo.tool?.toolName)
                    }
                  />
                </WithHint>
                {stylusInfo.stylus.renderTryPill()}
              </span>
            </WithSubMenu>
          );
        })}
      </TippyTargetProvider>
    </div>
  );
};

export default ApplicationView(StylusToolbar);
